module.exports = __webpack_public_path__ + "img/TCG_mockup.fb6bad45.png";